import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { AnswerService } from 'src/app/service/answer.service';
import { QuestionService } from 'src/app/service/question.service';

@Component({
  selector: 'app-survay',
  templateUrl: './survay.component.html',
  styleUrls: ['./survay.component.scss']
})
export class SurvayComponent implements OnInit {
  public ansBody:any = {
    question_label:'',
    answer_text:''
  }
  constructor(public qService:QuestionService, public aService:AnswerService,public notifier: NotifierService, private activatedRoute:ActivatedRoute,private router: Router) { }

  ngOnInit(): void {
    let utg_id = this.activatedRoute.snapshot.paramMap.get('id');
    this.qService.utg_id = utg_id ? utg_id : '';
    // console.log("this.activatedRoute.snapshot.params['utg_id']",this.activatedRoute.snapshot.paramMap.get('id'));
    this.activatedRoute.queryParams
    .subscribe(params => {
      if (params['nosplash']) {
        this.qService.initSurvay({"survey_id":params['survey_id'],"request_id":utg_id,"sid":params['sid']});
        // this..noSplash = true;
      }else{
        this.qService.initSurvay({"survey_id":params['survey_id'],"request_id":utg_id,"sid":params['sid'],'demoScreen':true});
        // this.noSplash = false;
      }
    }
  );
    
  }


  // next(){
  //   if (!this.ansBody.answer_text || this.ansBody.answer_text == '') {
  //     this.notifier.notify('error',"Please select a value");
  //     return;
  //   }
  //   this.aService.submitAnswer(this.ansBody);
  // }

}
